module.exports = __webpack_public_path__ + "img/etg.f7f73488.png";